
import Layers from "slotworks/graphics/layers/layers";
import Point from "slotworks/utils/geom/point";
import graphicsManager from "slotworks/graphics/graphics-manager";
import AnimatedSprite from "slotworks/graphics/animation/animated-sprite";
import Rectangle from "slotworks/utils/geom/rectangle";
import anticipationSupplement from "slotworks/model/gameplay/supplements/anticipation-supplement";
import slotDefinition from "slotworks/model/slot-definition";
import LinesComponent from 'slotworks/components/lines/lines-component';


export default class EmptyLinesComponent extends LinesComponent {

    constructor(lineDefinitions: Point[][]) {
        super(lineDefinitions);
    }

    public drawLines(lineDefinitions: Point[][]) {
        
    }

    public showBox(pos: Point) {
        
    }

    public hideBoxes() {
        
    }

    public showLine(index: number, show: boolean) {
        
    }

    public hideAllLines() {
        
    }

}
